export const profile = {
  name: 'Mohamed Suhail',
  role: 'Full-Stack Developer ',
  summary:
    'Former Flutter developer, now a React-focused full-stack engineer. I craft fast, accessible web apps with React/Next.js while still keeping a soft spot for Flutter — occasionally building mobile experiences too. Strong focus on performance, DX, and delightful UX across platforms.',
  socials: {
    github: 'https://github.com/yourusername',
    linkedin: 'https://www.linkedin.com/in/yourusername/',
    email: 'mailto:you@example.com',
  },
};

// Additional About content shown in the About section
export const aboutMore =
  'Today, I architect and ship production React/Next.js features end-to-end (API, state, animations), and when a project benefits from mobile, I prototype and deliver with Flutter/Dart. I love clean architecture, design systems, and making UIs feel effortless.';

export const projects = [
  {
    id: 'p1',
    title: 'Modern Portfolio (React + Flutter brand kit)',
    description: 'A stylish, animated React portfolio (Framer Motion) with a Flutter brand kit and shared design tokens.',
    tech: ['React', 'Framer Motion', 'CSS', 'Flutter', 'Dart'],
    demo: '#',
    source: '#',
    image:
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'p2',
    title: 'Shop Starter (Next.js + Flutter App)',
    description: 'Headless e-commerce: Next.js storefront with Stripe checkout and a companion Flutter mobile app.',
    tech: ['Next.js', 'Stripe', 'Tailwind', 'Flutter', 'Dart'],
    demo: '#',
    source: '#',
    image:
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'p3',
    title: 'Realtime Dashboard (React + Flutter Companion)',
    description: 'Realtime analytics dashboard in React with a Flutter companion app for push alerts and on-the-go insights.',
    tech: ['React', 'Socket.IO', 'Chart.js', 'Flutter', 'Dart'],
    demo: '#',
    source: '#',
    image:
      'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=1600&auto=format&fit=crop',
  },
  {
    id: 'p4',
    title: 'Flutter UI Kit + React Admin',
    description: 'A Flutter design system (mobile-first) paired with a React admin console sharing tokens and theming.',
    tech: ['Flutter', 'Dart', 'React', 'CSS'],
    demo: '#',
    source: '#',
    image:
      'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?q=80&w=1600&auto=format&fit=crop',
  },
];

export const experience = [
  {
    id: 'e1',
    role: 'Full-Stack Engineer (React-focused, with Flutter side projects)',
    company: 'Tech Co',
    period: '2022 — Present',
    highlights: [
      'Shifted focus from Flutter to full-stack React/Next.js in 2023; shipped web features with 35% faster TTI.',
      'Built a cross-platform component library used across web (React) and mobile (Flutter).',
      'Mentored 4 engineers and led accessibility and performance initiatives across projects.',
    ],
    tech: ['React', 'Next.js', 'TypeScript', 'Node.js', 'Flutter', 'Dart', 'Jest'],
  },
  {
    id: 'e2',
    role: 'Frontend Engineer (Flutter)',
    company: 'Startup Inc',
    period: '2020 — 2022',
    highlights: [
      'Developed and shipped cross-platform Flutter apps with strong performance and UX.',
      'Collaborated on a shared design system and documentation site.',
    ],
    tech: ['Flutter', 'Dart', 'Firebase', 'Storybook'],
  },
];

export const skills = [
  { title: 'Frontend', items: ['React', 'Next.js', 'TypeScript', 'Redux', 'Framer Motion', 'Tailwind'] },
  { title: 'Backend', items: ['Node.js', 'Express', 'REST', 'GraphQL'] },
  { title: 'Mobile & Cross-Platform', items: ['Flutter (occasional)', 'Dart', 'Firebase', 'Supabase'] },
  { title: 'Tools', items: ['Git', 'Jest', 'Vite', 'Webpack', 'Figma', 'Vercel'] },
];
